import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';

import { ResponsiveContext, Box, Text, Anchor } from 'grommet';
import { Calendar, Copy, Currency, Search } from 'grommet-icons';

import { toggleInsightsLayer } from '../../actions/insights';
import { formattedNumber } from '../../../../utils';

import urlRoutes from '../../../../config/url-routes';

const Dashboard = (props) => {
  const {
    //userLogged: {
    //  rules
    //},
    toggleInsightsLayer,
    history,
  } = props;

  return (
    <ResponsiveContext.Consumer>
      {size => (
        <Box
          direction='row'
          justify='center'
          margin={{ horizontal: 'medium', top: '100px' }}
        >
          <Box
            pad='small'
            width='xlarge'
            gap='medium'
          >
            {/* Cabeçalho */}
            <Box
              direction='row'
              gap='xsmall'
              align='baseline'
            >
              <Text size='large' color='dark-5'>Bem-vindo aos insights dos</Text>
              <Text size='xlarge' color='dark-1'>eleitores.</Text>
            </Box>

            {/* Conteúdo */}
            <Box
              gap='medium'
              direction={ size === 'small' || size === 'medium' ? 'column' : 'row' }
              justify='between'
            >
              {/* Primeira coluna */}
              <Box
                width={
                  size === 'small' || size === 'medium' ? 'xlarge' : 'xlarge'
                }
              >
                <Box
                  margin={{
                    bottom: size === 'small' ? 'large' : 'medium'
                  }}
                >
                  <Text color='dark-2' size='small'>
                    Uma maneira fácil e rápida de gerenciar os recursos recebidos e destinados.
                  </Text>
                </Box>

                <Box
                  direction='row'
                  gap={ size === 'small' ? 'large' : 'medium' }
                  margin={{ bottom: size === 'small' ? 'large' : 'medium' }}
                >
                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    align='baseline'
                    width='50vw'
                  >
                    <Currency size='medium' color='brand' />

                    <Text size='small' color='dark-2' weight='bold'>
                      Crie
                    </Text>

                    <Text size='small' color='dark-2'>
                      Registre todas as emendas ...
                    </Text>
                  </Box>

                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    align='baseline'
                    width='50vw'
                  >
                    <Search size='medium' color='brand' />

                    <Text size='small' color='dark-2' weight='bold'>
                      Busca avançada
                    </Text>

                    <Text size='small' color='dark-2'>
                      Filtre por tipo, estágio, secretaria e muito mais.
                    </Text>
                  </Box>
                </Box>

                <Box
                  direction='row'
                  gap={ size === 'small' ? 'large' : 'medium' }
                  margin={{ bottom: size === 'small' ? 'large' : 'medium' }}
                >
                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    align='baseline'
                    width='50vw'
                  >
                    <Calendar size='medium' color='brand' />

                    <Text size='small' color='dark-2' weight='bold'>
                      Crie lembretes
                    </Text>

                    <Text size='small' color='dark-2'>
                      Precisa atualizar daqui um tempo? Precisa cobrar alguma secretaria?
                      Crie um lembrete!
                    </Text>
                  </Box>

                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    align='baseline'
                    width='50vw'
                  >
                    <Copy size='medium' color='brand' />

                    <Text size='small' color='dark-2' weight='bold'>
                      Copie
                    </Text>

                    <Text size='small' color='dark-2'>
                      Crie uma nova emenda a partir de outra...
                    </Text>
                  </Box>
                </Box>
              </Box>


              {/* Separador coluna */}
              <Box
                width={ size === 'large' || size === 'xlarge' ? 'xxsmall' : 'xxsmall' }
              />


              {/* Segunda coluna */}
              <Box
                gap='small'
                width={ size === 'small' || size === 'medium' ? 'xlarge' : 'large' }
              >
                <Box
                  border={{
                    color: 'light-4',
                    side: 'all',
                  }}
                  round='small'
                  background='white'
                >
                  <Box
                    margin={{
                      vertical: 'small',
                      horizontal: 'medium'
                    }}
                    direction='row'
                    align='baseline'
                    gap='small'
                  >
                    <Text size='medium' color='dark-1'>Visão geral</Text>
                  </Box>

                  <Box
                    border={{
                      color: 'light-4',
                      side: 'top',
                    }}
                  />

                  <Box
                    margin={{ vertical: 'medium', horizontal: 'medium' }}
                    direction='row'
                    gap='small'
                  >
                    <Box
                      gap='xsmall'
                      pad={{ horizontal: 'xsmall' }}
                    >
                      <Text size='small' color='dark-3'>Pessoas cadastradas</Text>
                      <Text size='large' color='dark-2'>{formattedNumber(40000)}</Text>
                    </Box>

                    <Box
                      gap='xsmall'
                      pad={{ horizontal: 'xsmall' }}
                    >
                      <Text size='small' color='dark-3'>Votos conquistados</Text>
                      <Text size='large' color='neutral-1'>{formattedNumber(39717)}</Text>
                    </Box>

                    <Box
                      gap='xsmall'
                      pad={{ horizontal: 'xsmall' }}
                    >
                      <Anchor
                        color='brand'
                        label={<Text size='small'>mais...</Text>}
                        //onClick={ () => history.push(urlRoutes.voterListUrl) }
                        onClick={() => toggleInsightsLayer({ id: 1 })}
                      />
                    </Box>
                  </Box>
                </Box>

                <Box
                  margin={{ vertical: 'xsmall', horizontal: 'small' }}
                >
                  <Anchor
                    color='brand'
                    label={<Text size='small'>Acompanhar os cadastros...</Text>}
                    onClick={ () => history.push(urlRoutes.voterListUrl) }
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </ResponsiveContext.Consumer>
  );
};

const mapStateToProps = ({ authReducer: { authenticated } }) => ({
  userLogged: authenticated,
});

const mapDispatchToProps = dispath => {
  return bindActionCreators({
    toggleInsightsLayer,
  }, dispath)
};

export const DashboardResult = withRouter(connect(mapStateToProps, mapDispatchToProps)(Dashboard));
